require('./dlp-builder.component.scss');

export class DLPBuilderController {

  constructor(
    $scope,
    $rootScope,
    $element,
    $timeout,
  ) {
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.text = '';
    this.prevText = '';
    this.rules = [];
    this.compex = {};
    this.textOprers = {
      and: {
        type: 'oper',
        reg: '\\band\\b',
        buildKey: 'And',
      },
      '&&': {
        type: 'oper',
        reg: '\\&\\&',
        buildKey: 'And',
      },
      or: {
        type: 'oper',
        reg: '\\bor\\b',
        buildKey: 'Or',
      },
      '||': {
        type: 'oper',
        reg: '\\|\\|',
        buildKey: 'Or',
      },
      xor: {
        type: 'oper',
        reg: '\\bxor\\b',
        buildKey: 'eXclusive Or',
      },
      '^^': {
        type: 'oper',
        reg: '\\^\\^',
        buildKey: 'eXclusive Or',
      },
      '==': {
        type: 'expr',
        reg: '\\=\\=',
        buildKey: 'equals',
      },
      eq: {
        type: 'expr',
        reg: '\\beq\\b',
        buildKey: 'equals',
      },
      matches: {
        type: 'expr',
        reg: '\\bmatches\\b',
        buildKey: 'matches',
        nulti: true,
      },
      in: {
        type: 'expr',
        reg: '\\bin\\b',
        buildKey: 'in',
        nulti: true,
      },
      ne: {
        type: 'expr',
        reg: '\\bne\\b',
        buildKey: 'not equals',
      },
      '!=': {
        type: 'expr',
        reg: '\\!\\=',
        buildKey: 'not equals',
      },
      '!': {
        type: 'preExpr',
        reg: '\\!',
        buildKey: 'not',
      },
      'not': {
        type: 'preExpr',
        reg: '\\bnot\\b\\s',
        buildKey: 'not',
      },
    };

    this.builderOpers = {
      And: {
        type: 'oper',
        text: 'and',
      },
      Or: {
        type: 'oper',
        text: 'or',
      },
      'eXclusive Or': {
        type: 'oper',
        text: 'xor',
      },
      equals: {
        type: 'expr',
        text: '==',
      },
      'not equals': {
        type: 'expr',
        text: '!=',
      },
      matches: {
        type: 'expr',
        text: 'matches',
        multi: true,
      },
      'not matches': {
        type: 'expr',
        text: 'matches',
        pre: 'not',
        multi: true,
      },
      'in': {
        type: 'expr',
        text: 'in',
        multi: true,
      },
      'not in': {
        type: 'expr',
        text: 'in',
        pre: 'not',
        multi: true,
      },
    };
    this.arrOper = Object.keys(this.builderOpers).filter(k => this.builderOpers[k].type == 'oper');
    this.arrExpr = Object.keys(this.builderOpers).filter(k => this.builderOpers[k].type == 'expr');

    this.fields = {
      'computer_name': {
        dimension: 'agent_agent@computer_name:computer_name',
        name: gettext('Имя компьютера'),
        schemeType: 'Bytes',
        inputType: 'select',
      },
      'user_name': {
        dimension: 'agent_account@user_name:user_name',
        name: gettext('Имя пользователя'),
        schemeType: 'Bytes',
        inputType: 'select',
      },
      'user_domain': {
        dimension: 'agent_account@user_domain:user_domain',
        name: gettext('Домен пользователя'),
        schemeType: 'Bytes',
        inputType: 'select',
      },
      'exe_name': {
        dimension: 'agent_application@app_name:app_name',
        name: gettext('Имя приложения'),
        schemeType: 'Bytes',
        inputType: 'select',
      },
      'file_name': {
        dimension: 'agent_attachedfile@file_name:file_name',
        name: gettext('Имя файла'),
        schemeType: 'Bytes',
        inputType: 'select',
      },
      'file_path': {
        dimension: 'agent_attachedfile@file_path:file_path',
        name: gettext('Путь файла'),
        schemeType: 'Bytes',
        inputType: 'select',
      },
      'file_ext': {
        dimension: 'agent_attachedfile@file_ext:file_ext',
        name: gettext('Расширение файла'),
        schemeType: 'Bytes',
        inputType: 'select',
      },
      'mime': {
        dimension: 'agent_attachedfile@mime:mime',
        name: gettext('Тип контента'),
        schemeType: 'Bytes',
        inputType: 'select',
      },
      'tag': {
        dimension: 'boolean',
        name: gettext('Признак наличия метки'),
        schemeType: 'Bool',
        inputType: 'checkbox',
      },
      'tag_value': {
        dimension: 'value',
        name: gettext('Значение метки'),
        schemeType: 'Bytes',
        inputType: 'input',
      },
    };

    this.arrFields = Object.keys(this.fields).map(k => this.getFieldByKey(k));

    this.schemeFields = Object.keys(this.fields).reduce((f, k) => {
      f[k] = this.fields[k].schemeType;
      return f;
    }, {});

    this.dlpError = '';

    this.opersStr = Object.keys(this.textOprers)
      .filter(k => this.textOprers[k].type === 'oper')
      .map(k => this.textOprers[k].reg).join('|');

    this.exprStr = Object.keys(this.textOprers)
      .filter(k => this.textOprers[k].type === 'expr')
      .map(k => this.textOprers[k].reg).join('|');

    this.preExprStr = Object.keys(this.textOprers)
      .filter(k => this.textOprers[k].type === 'preExpr')
      .map(k => this.textOprers[k].reg).join('|');

    $timeout(() => {
      this.textarea = $element.find('.dlp-text textarea')[0];
      this.textarea.addEventListener('input', () => {
        this.textChanged = true;
        this.updateOutput();
        this.parseRules();
      });
    }, 10);

    this.textChanged = true;

  }

  $onDestroy() {
    this.textarea.target.removeEventListener('blur', this.parseRules);
    this.textarea.target.removeEventListener('onchange', this.updateOutput);
  }

  getFieldByKey(key) {
    const field = this.fields[key];
    if (!field) return null;
    field.key = key;
    return field;
  }

  $onInit() {
    this.$timeout(() => {
      this.textElement = this.$element.find(`#id_${this.fieldName}`);
      if (typeof WebAssembly === 'object') {
        this.createScheme().then(() => this.parseRules());
      } else {
        console.warn('DLP config validation diabled');
      }

    }, 100);
  }

  handleError(err) {
    // console.log(err);
    this.dlpError = err;
    // this.errorPanel.html(err.toString());
  }

  deleteExpr(oper, rule) {
    const ruleIndex = this.rules.indexOf(rule);
    if (ruleIndex == -1) return;
    const operIndex = this.rules[ruleIndex].indexOf(oper);
    if (operIndex == -1) return;
    // console.log(operIndex, ruleIndex);
    this.rules[ruleIndex].splice(operIndex, 1);
    if (!this.rules[ruleIndex].length) this.rules.splice(ruleIndex, 1);
    this.onFieldChange();
  }

  updateOutput() {
    let valid = true;
    try {
      const lines = this.textElement.val().split('\n');
      for (let i = 0; i < lines.length; i++) {
        const code = lines[i];
        if (code.trim()) {
          const res = this.scheme.parse(code);
          const value = JSON.stringify(res, null, 2);
        }
      }
      this.dlpError = '';
    } catch (err) {
      this.dlpError = err.message;
      if (this.textElement) valid = false;
    }
    $('input[name=_save]').prop('disabled', !valid);
    $('input[name=_saveasnew]').prop('disabled', !valid);
    this.$scope.$apply();
    this.textChanged = true;
  }

  createScheme() {
    return new Promise((resolve, reject) => {
      delete WebAssembly.instantiateStreaming;

      wasm_bindgen('/static/js/wirefilter_wasm_bg.wasm')
        .then(() => {
          if (!this.textElement.length) return;
          this.scheme = new wasm_bindgen.Scheme(this.schemeFields);
          resolve();
        });
      // const this.textElement = $('#id_dlp_config');
    });
  }

  onFieldChange(expr) {
    if (expr) {
      if (expr.field.key === 'tag') expr.value = [true];
      else expr.value = [''];
    }
    if (!$(this.textarea).is(':focus')) this.buildText();
  }

  parseValue(val, oper, field) {
    if (field === 'file_path') val = val.replace(/\\\\/g, '\\');
    if (!val[0]) return oper.trim() == 'not' ? [false] : [true];
    if (this.builderOpers[oper].text == 'matches') return val.match(/"\s*\((.+)\)\s*"/)[1].split('|');
    if (this.builderOpers[oper].text == 'in') return val.match(/([^\{^?"^\}]+)\b/g);
    return [val.match(/"(.+)"/)[1]];
  }

  parseExpr(expr, ruleIndex, rule) {
    // detting operator
    const operMatch = expr.match(new RegExp(`(${this.exprStr})`));
    let res;
    let operParts;
    if (operMatch && operMatch[0]) {
      operParts = expr.split(operMatch[0]);
      res = {
        oper: this.textOprers[operMatch[0].trim()].buildKey,
        value: operParts[1].trim(),
      };
    } else {
      operParts = [expr.trim()];
      res = {
        oper: '',
        value: [''],
      };
    }
    //checking is complicate rule
    if (operParts[0].match(/(?:\(|\))/)) {
      this.compex[ruleIndex] = rule;
      return;
    }

    //gettin prefix "not" or "!"
    let pre = operParts[0].match(/^(\s*not\s*|\s*\!\s*)+/);
    let field;
    if (pre) {
      pre = pre[0];
      //getting  without 'not'
      field = operParts[0].split(RegExp(`(${pre})`))[2].trim();
      //replacing '!' with `not`
      pre = pre.replace(/\!/g, 'not ');
      // adding strin with 'not ' to operation
      res.oper = `${pre} ${res.oper}`;
      //getting strin with 'not' including 'not' that belog to operation
      const preMatch = res.oper.match(/\s*(not\s+)/g);
      //getting field without 'not'
      const oper = res.oper.match(/\s*(?:not\s+)*(.+)/)[1].trim();
      // removing unnecessary 'not'
      if (preMatch && preMatch.length % 2) res.oper = `not ${oper}`;
      else res.oper = oper;
    } else {
      field = operParts[0].trim();
    }
    res.field = this.getFieldByKey(field);
    res.value = this.parseValue(res.value, res.oper, field);
    return res;
  }

  parseRules() {
    if (this.dlpError || !this.textChanged) return;
    const text = this.textElement.val();
    // if (this.prevText === text) return;
    this.prevText = text;
    this.compex = {};

    this.rules = text.split('\n').filter(s => s).map((s, ruleIndex) => {
      // divide by operations (last not inclused)
      const ruleMatch = s.split(new RegExp(`(${this.opersStr})`));
      const resMatch = [];
      for (let i = 0; i < ruleMatch.length; i += 2) {
        resMatch.push({
          expr: ruleMatch[i],
          oper: i < 1 ? '' : ruleMatch[i - 1],
        });
      }

      const opers = resMatch.map(o => ({
        oper: o.oper ? this.textOprers[o.oper.trim()].buildKey : '',
        expr: this.parseExpr(o.expr, ruleIndex, ruleIndex)
      }));

      //getting last operation
      return opers;
    });
    if (!this.$rootScope.$$phase) this.$scope.$apply();
    this.showBuilder = true;
    this.textChanged = false;
  }

  buildText() {
    const text = this.rules
      .map((r, i) => this.compex[i] ? this.compex[i] :
        r.filter(oper => {
          const isAll = oper.expr.field && ((oper.expr.oper && oper.expr.value[0]) || oper.expr.field.dimension === 'boolean');
          return isAll;
        }).map((oper, i) => {
          if (oper.expr.field.dimension == 'boolean')
            return (oper.oper && i ? this.builderOpers[oper.oper].text + ' ' : '') +
              (oper.expr.value[0] ? oper.expr.field.key : `not ${oper.expr.field.key}`);

          const exprOper = this.builderOpers[oper.expr.oper];
          let value = oper.expr.value;
          if (oper.expr.field.key === 'file_path') value = value.map(v => v.replace(/\\/g, '\\\\'));
          // in {“one” “two”}
          if (exprOper.text == 'in') value = `{${value.map(v => `"${v}"`).join(' ')}}`;
          //  matches "(guest|dsasd)"
          else if (exprOper.text == 'matches') value = `"(${value.map(v => v).join('|')})"`;
          else value = `"${value[0]}"`;

          return `${oper.oper && i? this.builderOpers[oper.oper].text + ' ':''}${
            exprOper.pre ? exprOper.pre + ' '  : ''}${
              oper.expr.field.key} ${exprOper.text} ${value}`;
        }).join(' ')).join('\n');

    this.textElement.val(text);
    this.prevText = text;
    this.$timeout(() => {
      this.updateOutput();
    }, 10);
  }

  isNextIndex(rule, oper) {
    const ruleIndex = this.rules.indexOf(rule);
    const operIndex = this.rules[ruleIndex].indexOf(oper);
    return operIndex > 0;
  }

  addExp(oper, rule) {
    const ruleIndex = this.rules.indexOf(rule);
    this.rules[ruleIndex].push({
      oper: oper,
      expr: {
        field: '',
        oper: '',
        value: ['']
      }
    });
    this.newRuleOper = '';
  }

  addRule() {
    this.rules.push([{
      oper: '',
      expr: {
        field: '',
        oper: '',
        value: ['']
      }
    }]);
  }

  deleteRule(rule) {
    const i = this.rules.indexOf(rule);
    if (i === -1) return;
    this.rules.splice(i, 1);
    delete this.compex[i];
    this.buildText();
  }

  isCompex(rule) {
    return this.compex[this.rules.indexOf(rule)];
  }

}

export const DLPBuilderComponent = {
  bindings: {
    fieldName: '<',
  },
  transclude: true,
  template: require('./dlp-builder.component.html'),
  controller: DLPBuilderController
};



// WEBPACK FOOTER //
// ./src/filter/dlp-builder/dlp-builder.component.js